"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GqlKetoProductCard = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.string.link.js");
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _variables = require("@nerdwallet/base-styles/variables");
var _reactMarketplaceApplyNow = require("@nerdwallet/react-marketplace-apply-now");
var _reactMarketplaceCta = _interopRequireDefault(require("@nerdwallet/react-marketplace-cta"));
var _reactOurTakeHighlight = require("@nerdwallet/react-our-take-highlight");
var _ketoProductCardModule = _interopRequireDefault(require("./keto-product-card.module.css"));
var _ketoHeader = require("./keto-header");
var _ketoImageRatingWrapper = require("./keto-image-rating-wrapper");
var _baseImpression = _interopRequireDefault(require("../impression/base-impression"));
var _constants = require("../lib/constants");
var _ketoDrivers = require("./keto-drivers");
var _accordionContent = require("./accordion-content");
var _baseKetoProductCard = require("./base-keto-product-card");
var _productCardImageWrapper = _interopRequireDefault(require("../product-card-image-wrapper"));
var _preheader = _interopRequireDefault(require("../preheader"));
var _utils = require("../lib/utils");
var _render = require("../lib/utils/render");
var _propTypes = require("../prop-types");
var _controlStatements = require("../control-statements");
var _drivers = require("../drivers");
var _cdApyDrivers = _interopRequireDefault(require("./cd-apy-drivers"));
var _addToFavorites = _interopRequireDefault(require("../product-ctas/add-to-favorites"));
var _bankingDrivers = _interopRequireDefault(require("./banking-drivers"));
var _templateObject;
var EntityPlacementCTATypeEnum;
(function (EntityPlacementCTATypeEnum) {
  EntityPlacementCTATypeEnum[EntityPlacementCTATypeEnum["APPLY_NOW"] = 0] = "APPLY_NOW";
  EntityPlacementCTATypeEnum[EntityPlacementCTATypeEnum["PREQUAL"] = 1] = "PREQUAL";
  EntityPlacementCTATypeEnum[EntityPlacementCTATypeEnum["READ_REVIEW"] = 2] = "READ_REVIEW";
})(EntityPlacementCTATypeEnum || (EntityPlacementCTATypeEnum = {})); // accordionProps that should be moved to the accordion file when it is moved to typescript
// driverProps that should be moved to the driver file when it is moved to typescript
// matchScoreCTA props that should be moved to the matchScoreCTA file once it is migrated to typescript
// imageAndRatingProps should be moved to the image and rating file when it is moved to typescript
var GqlKetoProductCard = function GqlKetoProductCard(_ref) {
  var _gqlMarketplaceEntity, _thisYearAwards$, _analyticsPayloadOver, _analyticsPayloadOver2, _analyticsPayloadOver3, _analyticsPayloadOver4, _analyticsPayloadOver5, _analyticsPayloadOver6, _analyticsPayloadOver7, _analyticsPayloadOver8, _analyticsPayloadOver9, _analyticsPayloadOver10, _analyticsPayloadOver11, _analyticsPayloadOver12, _analyticsPayloadOver13, _analyticsPayloadOver14, _analyticsPayloadOver15, _analyticsPayloadOver16;
  var analyticsPayloadOverrides = _ref.analyticsPayloadOverrides,
    approvalLikelihood = _ref.approvalLikelihood,
    approvalOddsEnabled = _ref.approvalOddsEnabled,
    bottomLineOverride = _ref.bottomLineOverride,
    checkboxLabel = _ref.checkboxLabel,
    className = _ref.className,
    compareCards = _ref.compareCards,
    consOverrides = _ref.consOverrides,
    _ref$consRenderer = _ref.consRenderer,
    consRenderer = _ref$consRenderer === void 0 ? _render.defaultRenderer : _ref$consRenderer,
    ccCompareHandler = _ref.ccCompareHandler,
    driversOverrides = _ref.driversOverrides,
    _ref$driversRenderer = _ref.driversRenderer,
    driversRenderer = _ref$driversRenderer === void 0 ? _render.defaultRenderer : _ref$driversRenderer,
    forceMobile = _ref.forceMobile,
    hasCCCompareButton = _ref.hasCCCompareButton,
    sideBySideCompareOptions = _ref.sideBySideCompareOptions,
    imageOverlay = _ref.imageOverlay,
    gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
    identity = _ref.identity,
    increaseCardImageSize = _ref.increaseCardImageSize,
    initAccordionItemExpanded = _ref.initAccordionItemExpanded,
    initOurTakeExpanded = _ref.initOurTakeExpanded,
    isSelectedToCompare = _ref.isSelectedToCompare,
    legacyTrkProps = _ref.legacyTrkProps,
    shouldOmitCta = _ref.shouldOmitCta,
    shouldOmitRating = _ref.shouldOmitRating,
    shouldOmitCreditScoreDriver = _ref.shouldOmitCreditScoreDriver,
    _ref$shouldEnableFavo = _ref.shouldEnableFavorites,
    shouldEnableFavorites = _ref$shouldEnableFavo === void 0 ? false : _ref$shouldEnableFavo,
    _ref$isFavorited = _ref.isFavorited,
    isFavorited = _ref$isFavorited === void 0 ? false : _ref$isFavorited,
    _ref$favoriteCallback = _ref.favoriteCallback,
    favoriteCallback = _ref$favoriteCallback === void 0 ? function () {} : _ref$favoriteCallback,
    preheader = _ref.preheader,
    prosOverrides = _ref.prosOverrides,
    _ref$prosRenderer = _ref.prosRenderer,
    prosRenderer = _ref$prosRenderer === void 0 ? _render.defaultRenderer : _ref$prosRenderer,
    reviewLinkOverride = _ref.reviewLinkOverride,
    showBestOfAwards = _ref.showBestOfAwards,
    showMatchScoreCTA = _ref.showMatchScoreCTA,
    showNotYetRated = _ref.showNotYetRated,
    _ref$shouldDisplayBon = _ref.shouldDisplayBonusChiclet,
    shouldDisplayBonusChiclet = _ref$shouldDisplayBon === void 0 ? false : _ref$shouldDisplayBon,
    _ref$shouldDisplayCdA = _ref.shouldDisplayCdApyDrivers,
    shouldDisplayCdApyDrivers = _ref$shouldDisplayCdA === void 0 ? false : _ref$shouldDisplayCdA,
    _ref$shouldDisplayOur = _ref.shouldDisplayOurTakeHighlight,
    shouldDisplayOurTakeHighlight = _ref$shouldDisplayOur === void 0 ? false : _ref$shouldDisplayOur,
    shouldDisplayPlaceHolder = _ref.shouldDisplayPlaceHolder,
    riaDisclaimerDetails = _ref.riaDisclaimerDetails,
    _ref$shouldHighlightD = _ref.shouldHighlightDrivers,
    shouldHighlightDrivers = _ref$shouldHighlightD === void 0 ? false : _ref$shouldHighlightD,
    _ref$shouldDisplayInl = _ref.shouldDisplayInlineCTA,
    shouldDisplayInlineCTA = _ref$shouldDisplayInl === void 0 ? false : _ref$shouldDisplayInl,
    _ref$tagLineRenderer = _ref.tagLineRenderer,
    tagLineRenderer = _ref$tagLineRenderer === void 0 ? _render.defaultRenderer : _ref$tagLineRenderer,
    riaReviewDateInfo = _ref.riaReviewDateInfo,
    setProductCardImpressionId = _ref.setProductCardImpressionId,
    postApplyOnClick = _ref.postApplyOnClick,
    showCreditScorePill = _ref.showCreditScorePill,
    trackNonMonetizingSegmentShoppingFinished = _ref.trackNonMonetizingSegmentShoppingFinished,
    _ref$isNwPlusVariant = _ref.isNwPlusVariant,
    isNwPlusVariant = _ref$isNwPlusVariant === void 0 ? false : _ref$isNwPlusVariant,
    _ref$isLimitedTimeOff = _ref.isLimitedTimeOffer,
    isLimitedTimeOffer = _ref$isLimitedTimeOff === void 0 ? false : _ref$isLimitedTimeOff;
  // because the preheader requires text anyway, we check that at least the text
  // is passed through. Before we would default to false for hasPreader even
  // when the preheader type is passed. Since we default to passing the type.
  var thisYearAwards = (_gqlMarketplaceEntity = gqlMarketplaceEntity.bestOfAwards) === null || _gqlMarketplaceEntity === void 0 ? void 0 : _gqlMarketplaceEntity.filter(function (value) {
    return value.year === new Date().getFullYear();
  });
  // eslint-disable-next-line no-param-reassign
  if (shouldHighlightDrivers || shouldDisplayInlineCTA) forceMobile = true;
  var hasPreheader = showBestOfAwards && !(0, _isEmpty2.default)(thisYearAwards) && !!((_thisYearAwards$ = thisYearAwards[0]) !== null && _thisYearAwards$ !== void 0 && _thisYearAwards$.category) || !(0, _isEmpty2.default)(preheader) && !!(preheader !== null && preheader !== void 0 && preheader.text);
  var imageData = (0, _utils.getKetoCardLazyLoadableImageData)(gqlMarketplaceEntity);
  var productCardImage = /*#__PURE__*/_react.default.createElement(_productCardImageWrapper.default, {
    imageData: imageData,
    backgroundColor: _variables.colors.transparent,
    imageClassName: _ketoProductCardModule.default.productImage,
    className: _ketoProductCardModule.default.productImageWrapper,
    objectFit: "contain",
    lazyLoadEnabled: true,
    isKetoCard: true,
    imageOverlay: imageOverlay,
    shouldDisplayPlaceHolder: shouldDisplayPlaceHolder
  });
  var analyticsProps = gqlMarketplaceEntity.analyticsProps,
    cta = gqlMarketplaceEntity.cta,
    monetizable = gqlMarketplaceEntity.monetizable,
    legacyId = gqlMarketplaceEntity.legacyId,
    productType = gqlMarketplaceEntity.productType,
    termsAndFeesLink = gqlMarketplaceEntity.termsAndFeesLink;
  // get all the added cardIds from the compare bar
  var cardIDsToCompare = (0, _get2.default)(compareCards, 'cardIDsToCompare') || [];

  // if the boolean isSelectedToCompare is defined (true/false) we will use the value,
  // if not, we will cardIDsToCompare and check if the
  // card id already added in the cardIDsToCompare;
  // then display the checkbox checked=true
  var isInCompare = !(0, _isNil2.default)(isSelectedToCompare) ? isSelectedToCompare : cardIDsToCompare.indexOf(legacyId) > -1;
  var preheaderData = {
    type: preheader === null || preheader === void 0 ? void 0 : preheader.type,
    text: preheader === null || preheader === void 0 ? void 0 : preheader.text,
    title: preheader === null || preheader === void 0 ? void 0 : preheader.title
  };
  if (showBestOfAwards && thisYearAwards !== null && thisYearAwards !== void 0 && thisYearAwards.length) {
    var thisYearAwardsText = thisYearAwards.map(function (value) {
      return value.category;
    }).join(', ');
    if (preheaderData.type !== _constants.PREHEADER_TYPE.BADGE_2022) {
      preheaderData.type = _constants.PREHEADER_TYPE.BADGE;
    }
    preheaderData.text = thisYearAwardsText;
    preheaderData.title = thisYearAwardsText;
  }
  var preheaderType = preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.type;
  var productCardPreheader = hasPreheader ? /*#__PURE__*/_react.default.createElement(_preheader.default, {
    className: _ketoProductCardModule.default.preheader,
    trkTaxonomy: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkTaxonomy,
    text: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.text,
    title: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.title,
    trkPageType: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkPageType,
    sentiment: preheader === null || preheader === void 0 ? void 0 : preheader.sentiment,
    type: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.type,
    url: preheader === null || preheader === void 0 ? void 0 : preheader.url,
    isKetoCard: true
  }) : null;
  var isPreheaderBadge = preheaderType === _constants.PREHEADER_TYPE.BADGE || preheaderType === _constants.PREHEADER_TYPE.BADGE_2022 || [_constants.PREHEADER_TYPE.BADGE_2024, _constants.PREHEADER_TYPE.BADGE_2025].includes(preheaderType);
  var mpcTrkSectionCategory = (0, _utils.buildTrkSectionCategory)(legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkSectionCategory, _constants.TRK_PRODUCT_LOCATION);
  var secondaryCtaHref = termsAndFeesLink;
  var secondaryCtaText = 'Rates & Fees';
  var secondaryCtas = secondaryCtaHref ? /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
    analyticsPayloadOverrides: {
      sectionName: (analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver === void 0 ? void 0 : (_analyticsPayloadOver2 = _analyticsPayloadOver.payload) === null || _analyticsPayloadOver2 === void 0 ? void 0 : _analyticsPayloadOver2.section_name) || "keto_product_card",
      sectionPosition: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver3 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver3 === void 0 ? void 0 : (_analyticsPayloadOver4 = _analyticsPayloadOver3.payload) === null || _analyticsPayloadOver4 === void 0 ? void 0 : _analyticsPayloadOver4.section_position,
      product_impression_id: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver5 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver5 === void 0 ? void 0 : _analyticsPayloadOver5.productImpressionId
    },
    className: _ketoProductCardModule.default.secondaryCta,
    cta: {
      link: secondaryCtaHref,
      text: secondaryCtaText,
      // although this is a rates and fees shopping finished event we want the
      // component to be an ApplyNowLink so that it's a link with the tracking
      type: 'APPLY_NOW'
    },
    id: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    omitImpression: true,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished
  }) : null;
  var alternateCtaNode = shouldHighlightDrivers && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.applyNow
  }, /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
    analyticsPayloadOverrides: {
      element_position: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkProductPosition,
      product_impression_id: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver6 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver6 === void 0 ? void 0 : _analyticsPayloadOver6.productImpressionId
    },
    className: _ketoProductCardModule.default.productLink,
    disableAnnotation: !!(cta !== null && cta !== void 0 && cta.subtext) === false,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__product-button--under-image--").concat((_analyticsPayloadOver7 = analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.element_position) !== null && _analyticsPayloadOver7 !== void 0 ? _analyticsPayloadOver7 : ''),
    legacyTrkProps: {
      trkPageType: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkPageType,
      trkSectionCategory: (0, _utils.buildTrkSectionCategory)(legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkSectionCategory, 'cta'),
      trkTaxonomy: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkTaxonomy
    },
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.applyNowButton,
    omitImpression: true,
    reviewLinkOverride: reviewLinkOverride,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.starRating
  }, secondaryCtas));
  var ourTakeHighlight = null;
  if (shouldDisplayOurTakeHighlight && gqlMarketplaceEntity) {
    var marketingBullets = gqlMarketplaceEntity.marketingBullets;
    ourTakeHighlight = (0, _reactOurTakeHighlight.findOurTakeHighlightContent)(marketingBullets);
  }
  var driversNode = shouldHighlightDrivers ? /*#__PURE__*/_react.default.createElement(_drivers.GqlProductDrivers, {
    analytics: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.driverProps,
    approvalOddsEnabled: true,
    className: _ketoProductCardModule.default.drivers,
    driversRenderer: driversRenderer,
    identity: identity,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    placementDrivers: driversOverrides || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.placementDrivers),
    shouldShowMatchScoreCta: false,
    shouldOmitCreditScoreDriver: false,
    horizontalMobileDrivers: true,
    showCreditScorePill: showCreditScorePill
  }) : /*#__PURE__*/_react.default.createElement(_ketoDrivers.GqlKetoCardDrivers, {
    analytics: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.driverProps,
    approvalLikelihood: approvalLikelihood,
    approvalOddsEnabled: approvalOddsEnabled,
    className: _ketoProductCardModule.default.drivers,
    driversOverrides: driversOverrides,
    driversRenderer: driversRenderer,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    identity: identity,
    reviewLinkOverride: reviewLinkOverride,
    showMatchScoreCTA: showMatchScoreCTA,
    showNotYetRated: showNotYetRated,
    shouldOmitCreditScoreDriver: shouldOmitCreditScoreDriver,
    showCreditScorePill: showCreditScorePill
  });
  if (shouldDisplayCdApyDrivers && driversOverrides) {
    driversNode = /*#__PURE__*/_react.default.createElement(_cdApyDrivers.default, {
      drivers: driversOverrides
    });
  }
  if (shouldDisplayBonusChiclet || isLimitedTimeOffer) {
    driversNode = /*#__PURE__*/_react.default.createElement(_bankingDrivers.default, {
      drivers: driversOverrides || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.placementDrivers),
      isLimitedTimeOffer: isLimitedTimeOffer
    });
  }
  var header = /*#__PURE__*/_react.default.createElement(_ketoHeader.GraphQLKetoProductCardHeader, {
    className: hasPreheader ? _ketoProductCardModule.default.header : _ketoProductCardModule.default.headerWithNoPreHeader,
    marketplaceEntity: gqlMarketplaceEntity,
    omitCta: shouldOmitCta
    // compare button specific props
    ,
    hasCompareButton: hasCCCompareButton,
    handleCompare: ccCompareHandler,
    checkboxLabel: checkboxLabel,
    isSelectedToCompare: isSelectedToCompare
    // BNK specific props
    ,
    isPreheaderBadge: isPreheaderBadge,
    hasPreheader: hasPreheader,
    productCardPreheader: productCardPreheader,
    reviewLinkOverride: reviewLinkOverride,
    legacyTrkProps: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, legacyTrkProps), {}, {
      trkSectionCategory: mpcTrkSectionCategory
    }),
    addToFavoritesNode: shouldEnableFavorites ? /*#__PURE__*/_react.default.createElement(_addToFavorites.default, {
      isFavorited: isFavorited,
      favoriteCallback: favoriteCallback,
      isMobile: true
    }) : null,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished
  });
  return /*#__PURE__*/_react.default.createElement(_baseImpression.default, {
    analytics: (_analyticsPayloadOver8 = analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.productImpressionProps) !== null && _analyticsPayloadOver8 !== void 0 ? _analyticsPayloadOver8 : {
      payload: {}
    },
    destinationUrl: cta === null || cta === void 0 ? void 0 : cta.link,
    elementPosition: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver9 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver9 === void 0 ? void 0 : _analyticsPayloadOver9.elementPosition,
    marketplaceInstitutionId: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.institutionId,
    marketplaceOfferId: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.offerId,
    marketplaceProductId: analyticsProps === null || analyticsProps === void 0 ? void 0 : analyticsProps.productId,
    marketplaceProductType: productType,
    monetizable: monetizable,
    sectionName: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver10 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver10 === void 0 ? void 0 : _analyticsPayloadOver10.sectionName,
    sectionPosition: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver11 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver11 === void 0 ? void 0 : _analyticsPayloadOver11.sectionPosition,
    setProductCardImpressionId: setProductCardImpressionId
  }, /*#__PURE__*/_react.default.createElement(_baseKetoProductCard.BaseKetoProductCard, {
    accordionNode: /*#__PURE__*/_react.default.createElement(_accordionContent.GqlKetoAccordion, {
      analytics: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.accordionProps,
      bottomLineOverride: bottomLineOverride,
      consOverrides: consOverrides,
      consRenderer: consRenderer,
      gqlMarketplaceEntity: gqlMarketplaceEntity,
      initAccordionItemExpanded: initAccordionItemExpanded,
      initOurTakeExpanded: initOurTakeExpanded,
      prosOverrides: prosOverrides,
      prosRenderer: prosRenderer,
      tagLineRenderer: tagLineRenderer
    }),
    className: className,
    driversNode: driversNode,
    forceMobile: forceMobile,
    headerNode: !shouldDisplayInlineCTA && header,
    sideBySideCompareOptions: sideBySideCompareOptions,
    handleCompare: ccCompareHandler,
    checkboxLabel: checkboxLabel,
    isSelectedToCompare: isSelectedToCompare,
    imageAndRatingNode: /*#__PURE__*/_react.default.createElement(_ketoImageRatingWrapper.GraphQLKetoImageAndRating, {
      analytics: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.imageAndRatingProps), {}, {
        product_impression_id: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver12 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver12 === void 0 ? void 0 : _analyticsPayloadOver12.productImpressionId
      }),
      approvalLikelihood: approvalLikelihood,
      disableAnnotation: !!(cta !== null && cta !== void 0 && cta.subtext) === false,
      imageDataSource: imageData === null || imageData === void 0 ? void 0 : imageData.src,
      increaseCardImageSize: increaseCardImageSize && !shouldHighlightDrivers,
      id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__product-button--under-image--").concat((_analyticsPayloadOver13 = analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.element_position) !== null && _analyticsPayloadOver13 !== void 0 ? _analyticsPayloadOver13 : ''),
      identity: identity,
      legacyTrkProps: legacyTrkProps,
      marketplaceEntity: gqlMarketplaceEntity,
      shouldOmitCta: shouldOmitCta,
      shouldOmitRating: shouldOmitRating,
      productCardImage: productCardImage,
      secondaryCtas: secondaryCtas,
      reviewLinkOverride: reviewLinkOverride
      // BNK specific props
      ,
      showNotYetRated: showNotYetRated
      // CC specific props
      ,
      showMatchScoreCTA: showMatchScoreCTA,
      riaDisclaimerDetails: riaDisclaimerDetails,
      shouldHighlightDrivers: shouldHighlightDrivers,
      riaReviewDateInfo: riaReviewDateInfo,
      shouldDisplayInlineCTA: shouldDisplayInlineCTA,
      header: header,
      postApplyOnClick: postApplyOnClick,
      trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished,
      isNwPlusVariant: isNwPlusVariant
    }),
    isInCompare: isInCompare,
    isPreheaderBadge: isPreheaderBadge,
    ourTakeHighlight: ourTakeHighlight,
    sectionName: (_analyticsPayloadOver14 = analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : (_analyticsPayloadOver15 = analyticsPayloadOverrides.productImpressionProps) === null || _analyticsPayloadOver15 === void 0 ? void 0 : (_analyticsPayloadOver16 = _analyticsPayloadOver15.payload) === null || _analyticsPayloadOver16 === void 0 ? void 0 : _analyticsPayloadOver16.section_name) !== null && _analyticsPayloadOver14 !== void 0 ? _analyticsPayloadOver14 : 'keto_product_card',
    alternateCta: alternateCtaNode,
    isNwPlusVariant: isNwPlusVariant,
    isLimitedTimeOffer: isLimitedTimeOffer
  }));
};
exports.GqlKetoProductCard = GqlKetoProductCard;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  GqlKetoProductCard.propTypes = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({
    analyticsPayloadOverrides: PropTypes.shape({
      enabled: PropTypes.bool,
      // this should always be true if you want analytics on and won't respect the false.
      element_position: PropTypes.number
    }),
    approvalLikelihood: PropTypes.number,
    approvalOddsEnabled: PropTypes.bool,
    bottomLineOverride: PropTypes.node,
    ccCompareHandler: PropTypes.func,
    checkboxLabel: PropTypes.string,
    className: PropTypes.string,
    consOverrides: PropTypes.arrayOf(PropTypes.node),
    // eslint-disable-next-line react/forbid-prop-types
    compareCards: PropTypes.object,
    forceMobile: PropTypes.bool,
    gqlMarketplaceEntity: PropTypes.shape({
      analyticsProps: PropTypes.shape({
        institutionId: PropTypes.string,
        offerId: PropTypes.string,
        productId: PropTypes.string
      }),
      bestOfAwards: PropTypes.arrayOf(PropTypes.shape({
        year: PropTypes.number,
        category: PropTypes.string
      })),
      image: PropTypes.shape({
        alt: PropTypes.string,
        source: PropTypes.string
      }),
      structuredContentCons: _constants.StructuredContentPropType,
      structuredContentPros: _constants.StructuredContentPropType,
      structuredContentTagline: _constants.StructuredContentPropType,
      termsAndFeesLink: PropTypes.string
    }),
    hasCCCompareButton: PropTypes.bool,
    sideBySideCompareOptions: PropTypes.shape({
      variantPosition: PropTypes.bool
    }),
    identity: PropTypes.oneOfType([PropTypes.shape({
      vantageScore3: PropTypes.number
    }), PropTypes.shape({
      profiles: PropTypes.shape({
        tu_credit_report_profile: PropTypes.shape({
          vantage_score_3: PropTypes.number
        })
      })
    })]),
    imageOverlay: PropTypes.node,
    increaseCardImageSize: PropTypes.bool,
    initAccordionItemExpanded: PropTypes.bool,
    initOurTakeExpanded: PropTypes.bool,
    isSelectedToCompare: PropTypes.bool,
    legacyTrkProps: PropTypes.shape({
      // trkElement: PropTypes.string,
      trkPageType: PropTypes.string,
      trkProductPosition: PropTypes.number,
      trkTaxonomy: _propTypes.TRKPropTypes
    }),
    // CC Specific Props
    preheader: PropTypes.shape({
      sentiment: PropTypes.oneOf((0, _values2.default)(_constants.SENTIMENT_TYPE)),
      text: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string
    }),
    prosOverrides: PropTypes.arrayOf(PropTypes.node),
    shouldOmitCta: PropTypes.bool,
    shouldOmitRating: PropTypes.bool,
    shouldOmitCreditScoreDriver: PropTypes.bool,
    showMatchScoreCTA: PropTypes.bool,
    shouldHighlightDrivers: PropTypes.bool,
    shouldDisplayBonusChiclet: PropTypes.bool,
    shouldDisplayCdApyDrivers: PropTypes.bool,
    shouldDisplayInlineCTA: PropTypes.bool
  }, _accordionContent.GqlKetoAccordion.propTypes), _ketoDrivers.GqlKetoCardDrivers.propTypes), _ketoHeader.GraphQLKetoProductCardHeader.propTypes), _ketoImageRatingWrapper.GraphQLKetoImageAndRating.propTypes);
}
GqlKetoProductCard.defaultProps = {
  analyticsPayloadOverrides: {},
  approvalOddsEnabled: true,
  forceMobile: false,
  increaseCardImageSize: false,
  initAccordionItemExpanded: false,
  initOurTakeExpanded: false,
  legacyTrkProps: {
    trkTaxonomy: (0, _get2.default)(global.window, 'nwPageTaxonomy')
  },
  preheader: {
    type: _constants.PREHEADER_TYPE.PLAIN_TEXT
  },
  showMatchScoreCTA: false,
  shouldHighlightDrivers: false,
  shouldDisplayBonusChiclet: false,
  shouldDisplayCdApyDrivers: false,
  shouldDisplayInlineCTA: false
};
GqlKetoProductCard.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment KetoProductCard on MarketplaceEntityInterface {\n    ... on CreditCardsOfferV2 {\n      legacyId\n      termsAndFeesLink\n    }\n\n    ... on MarketplaceEntityWithBestOfAwardsInterface {\n      bestOfAwards {\n        year\n        category\n      }\n    }\n\n    ... on MarketplaceEntityWithPlacementInterface {\n      analyticsProps {\n        institutionId\n        offerId\n        productId\n      }\n      cta {\n        link\n        subtext\n      }\n      displayName\n      image {\n        alt\n        source\n      }\n      monetizable\n      structuredContentCons\n      structuredContentPros\n      structuredContentTagline\n    }\n\n    ...CdApyDrivers\n    ...GraphQLKetoProductCardHeader\n    ...GraphQLKetoImageAndRating\n    ...GqlKetoCardDrivers\n    ...GqlKetoAccordion\n    ...MarketplaceCta\n    ...getLazyLoadableImageData\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), _cdApyDrivers.default.fragment, _ketoHeader.GraphQLKetoProductCardHeader.fragment, _ketoImageRatingWrapper.GraphQLKetoImageAndRating.fragment, _ketoDrivers.GqlKetoCardDrivers.fragment, _accordionContent.GqlKetoAccordion.fragment, _reactMarketplaceCta.default.fragment, _utils.getKetoCardLazyLoadableImageData.fragment);
GqlKetoProductCard.displayName = 'GqlKetoProductCard';
var _default = GqlKetoProductCard;
exports.default = _default;